module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/French Bread-38c5b2e737a49212d576c91251cfe060.svg";